export default function Footer() {
  return (
    <footer className="border-t-2 border-ink bg-ink text-white mt-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <div className="font-display font-black text-3xl uppercase">LeadTitan</div>
          <p className="font-mono text-xs uppercase tracking-widest mt-2 text-acid">// pros meet customers</p>
          <p className="text-sm text-white/70 mt-4 max-w-xs">
            The high-signal lead network. Vetted pros. Real customers. No noise.
          </p>
        </div>
        <div>
          <div className="overline text-acid mb-3">For Customers</div>
          <ul className="space-y-2 text-sm">
            <li>Post a project</li>
            <li>Browse pros</li>
            <li>Reviews</li>
          </ul>
        </div>
        <div>
          <div className="overline text-acid mb-3">For Pros</div>
          <ul className="space-y-2 text-sm">
            <li>Buy leads</li>
            <li>Subscriptions</li>
            <li>Grow your business</li>
          </ul>
        </div>
        <div>
          <div className="overline text-acid mb-3">Contact</div>
          <ul className="space-y-2 text-sm">
            <li>
              <a href="mailto:support@lead-titan.net" className="hover:text-acid transition-colors" data-testid="footer-contact-email">
                support@lead-titan.net
              </a>
            </li>
            <li>1-800-LEADS</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/20 py-4 text-center font-mono text-xs uppercase tracking-widest text-white/50">
        © {new Date().getFullYear()} LeadTitan — Built for pros.
      </div>
    </footer>
  );
}
